import z from "zod";
import { apiClient } from "../commonApis/apiClient";
import { ShipmentInventoryAddPayloadSchema } from "../hooks/inventoryHooks";

export interface ShipmentInventory {
  id: string;
  [key: string]: any;
}

export interface ShipmentInventoryResponse {
  data: string;
}

// API response shape
export interface ShipmentInventoryResponse {
  inventoryMovement: ShipmentInventory[];
  total: number;
  page: number;
  totalPages: number;
}

export interface ShipmentInventoryVerifyPayload {
  locationId?: string;
  awb?: string;
  barcodeId?: string;
}

export type ShipmentInventoryAddPayload = z.infer<
  typeof ShipmentInventoryAddPayloadSchema
>;

export const shipmentInventoryApi = {
  getShipmentInventory: (pageNo: number, limit: number, searchFor: string) =>
    apiClient.get<ShipmentInventoryResponse>(`/api/outlet/inventory-movement?type=outlet
&page=${pageNo}&limit=${limit}`),

  shipmentInventoryAdd: (
    payload: ShipmentInventoryAddPayload | FormData,
    isFormData: boolean = false,
  ) =>
    apiClient.post<ShipmentInventory>(
      `/api/outlet/inventory-movement?type=outlet`,
      payload,
      isFormData,
    ),

  getShipmentInventoryByLocationId: (
    locatoinId: string,
    pageNo: number,
    limit: number,
    searchFor: string,
  ) =>
    apiClient.get<ShipmentInventory>(
      `/api/outlet/inventory-movement/by-location/${locatoinId}?type=outlet&page=${pageNo}&limit=${limit}&searchFor=${searchFor}`,
    ),

  verifyShipmentInventory: (
    payload: ShipmentInventoryVerifyPayload | FormData,
  ) =>
    apiClient.post<ShipmentInventory>(
      `/api/outlet/inventory-movement/verify?type=outlet`,
      payload,
    ),

  deleteShipmentInventory: (
    payload: ShipmentInventoryVerifyPayload | FormData,
  ) =>
    apiClient.delete<void>(
      `/api/outlet/inventory-movement?type=outlet`,
      payload,
    ),

  verifyLocationBarcode: (payload: ShipmentInventoryVerifyPayload | FormData) =>
    apiClient.post<ShipmentInventoryResponse>(
      `/api/outlet/inventory-movement/location-verify?type=outlet`,
      payload,
    ),
};


